import {takeLatest, takeEvery, all} from 'redux-saga/effects';
import {call, put} from 'redux-saga/effects';
import axios from 'axios';
import {actionTypes, actions} from '../Redux/index';
import qs from 'qs';

import api from "../endpoint";


const apiConfig = {
    [actionTypes.Data.Currency.REQUEST_HOLIDAYS]: {
        endpoint: '/currency/holidays',
        successAction: actions.Data.Currency.sagaLoadHolidaysSuccess,
        usePayloadAsParams: true,
    },
    [actionTypes.System.INIT]: {
        endpoint: '/currency',
        successAction: actions.Data.Currency.sagaLoadDataSuccess,
    },
};

function* fetchConfiguredApiData(args) {
    const config = apiConfig[args.type];
    if (!config) return;

    const { endpoint, successAction, usePayloadAsParams } = config;
    const queryParams = usePayloadAsParams ? args.payload : undefined;

    try {
        yield put(actions.Data.Currency.sagaLoadHolidaysStart());

        const requestConfig = {
            baseURL: api,
            url: endpoint,
            withCredentials: false,
            responseType: 'json',
            crossDomain: true
        };

        if (queryParams) {
            requestConfig.params = queryParams;
            // the default behavior for serializing parameter arrays is
            // ?foo[]=bar1&foo[]=bar2
            // but we want this
            // ?foo=bar1&foo=bar2
            requestConfig.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });
        }

        const response = yield call(axios.get, requestConfig.url, requestConfig);
        //console.log("Response Data - ", response);
        yield put(successAction(response.data));

        // If this was the initial currency load, signal that the system is ready
        if (args.type === actionTypes.System.INIT) {
            yield put({ type: 'SYSTEM_READY' });
        }

    } catch (e) {
        console.error(e);
    }

}

export default function* getApiData() {
    yield all([
        takeEvery(actionTypes.System.INIT, fetchConfiguredApiData),
        takeLatest(actionTypes.Data.Currency.REQUEST_HOLIDAYS, fetchConfiguredApiData)
    ]);
}
